module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit2-9a871bd14a04f714e0c2f50fd797e2ce.png";